exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-width {\r\n    width: 100%;\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    -ms-flex-line-pack: center;\r\n        align-content: center;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/agent-force-logout/agent-force-logout.component.css
// module id = ../../../../../src/app/agent-force-logout/agent-force-logout.component.css
// module chunks = 0